import { useContext } from "react"
import { IconEnvelopeBanOutline18 as MailX } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

import {
	settingsNavGroupClass,
	SettingsNavRow,
} from "../settings-pages/settings-nav-row"
import { SettingsCardInsetContext } from "../settings-switches/settings-container"

export const BlockedEmailAddressesCard = () => {
	const inset = useContext(SettingsCardInsetContext)
	return (
		<div className={cn(settingsNavGroupClass, !inset && "sm:mx-0")}>
			<SettingsNavRow
				icon={MailX}
				title="Blocked email addresses"
				description="Emails from these addresses or domains will be automatically ignored."
				link="/settings/emails/blocked"
			/>
		</div>
	)
}
